import { useState } from "react";
import { useUserData } from "context/OAuth/AuthContext";
import AlertModal from "@components/ui/AlertModal";
import { useNavigate } from "react-router-dom";

const RecreateButton = ({
  recreatePlan,
  isMealPlanLoading,
  planPending,
  t,
}) => {
  // const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const { subscription } = useUserData();
  const navigate = useNavigate();
  return (
    <div>
      {/* {recreatePlan && !(isMealPlanLoading || planPending) && ( */}
      <button
        onClick={() =>
          subscription?.status === "active" || subscription?.status === "pending-cancel"
            ? navigate("/diet-plan/preferences", {
                state: { dietPlan: true, isReacreate: true },
              })
            : navigate("/renew-subscription")
        }
        className={`px-[20px] py-[10px] bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white rounded-[100px] text-[12px] ${
          !recreatePlan &&
          "opacity-[0.7] pointer-events-none"
        }`}
        disabled={!recreatePlan}
      >
        {t("dietPlanDashboard.allMeals.recreateMeal")}
      </button>
      {/* )} */}
      {/* <AlertModal
        heading="Congratulations! Your Exercise Plan Subscription is Renewed"
        message="You’re all set to keep crushing your goals! Regenerate your Exercise plan if you're ready for something new."
        buttonText="Regenerate Plan"
        cancelText="Close"
        showModal={showSubscriptionModal}
        dietPlan={false}
        setShowModal={setShowSubscriptionModal}
      /> */}
    </div>
  );
};

export default RecreateButton;
